import { React, useState } from 'react'
import { SiHashnode } from 'react-icons/si'

import { frontSkills, backSkills, ToolsTechs } from './data'
import { Container, Card } from 'react-bootstrap'
const SkillsGroup = () => {
  // eslint-disable-next-line
  const [FSkill, setSkill] = useState(frontSkills)
  // eslint-disable-next-line
  const [BSkill, setBSkill] = useState(backSkills)
  // eslint-disable-next-line
  const [tools, setTools] = useState(ToolsTechs)
  return (
    <Container>
      <h1 className='mb-3'>Skills & Tools</h1>

      <Card bg='dark' text='light' className='mb-2'>
        <Card.Header>
          <SiHashnode /> Front-End Skills
        </Card.Header>
        <Card.Body>
          <Card.Text>
            {FSkill.map((skill) => {
              return (
                <h4 key={skill.id} className='mb-2'>
                  {skill.icon} {skill.name}
                </h4>
              )
            })}
          </Card.Text>
        </Card.Body>
      </Card>

      <Card bg='dark' text='light' className='mb-2'>
        <Card.Header>
          <SiHashnode /> Back-End Skills
        </Card.Header>
        <Card.Body>
          <Card.Text>
            {BSkill.map((skill) => {
              return (
                <h4 key={skill.id}>
                  {skill.icon} {skill.name}
                </h4>
              )
            })}
          </Card.Text>
        </Card.Body>
      </Card>
      <Card bg='dark' text='light' className='mb-2'>
        <Card.Header>
          <SiHashnode /> Other Tools
        </Card.Header>
        <Card.Body>
          <Card.Text>
            {tools.map((tool) => {
              return (
                <h4 key={tool.id}>
                  {tool.icon} {tool.name}
                </h4>
              )
            })}
          </Card.Text>
        </Card.Body>
      </Card>
    </Container>
  )
}

export default SkillsGroup
